import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { CTAButton } from './CTAButton';
const TESTIMONIALS = [{
  name: 'María Fernanda L.',
  age: 34,
  city: 'Buenos Aires',
  quote: 'Siempre quise aprender Reiki pero los cursos presenciales eran imposibles con mi trabajo. Este MegaPack me cambió la vida. En 3 meses ya estoy haciendo sesiones a mi familia y amigos. ¡Increíble!',
  stars: 5,
  initials: 'MF'
}, {
  name: 'Roberto C.',
  age: 52,
  city: 'Córdoba',
  quote: 'A mi edad pensé que era tarde para empezar algo nuevo. Los manuales son tan claros y completos que pude avanzar a mi ritmo. Hoy soy Maestro de Reiki y doy talleres en mi ciudad.',
  stars: 5,
  initials: 'RC'
}, {
  name: 'Luciana M.',
  age: 28,
  city: 'Rosario',
  quote: 'Lo mejor es que incluye TODO. No tuve que buscar nada extra. Las meditaciones guiadas son hermosas y los certificados le dan un toque muy profesional.',
  stars: 5,
  initials: 'LM'
}, {
  name: 'Jorge A.',
  age: 45,
  city: 'Mendoza',
  quote: 'Soy médico y buscaba complementar mi práctica con medicina alternativa. El MegaPack tiene un nivel de detalle y seriedad que me sorprendió. Muy recomendable.',
  stars: 5,
  initials: 'JA'
}, {
  name: 'Valentina S.',
  age: 31,
  city: 'La Plata',
  quote: 'Empecé sin saber nada de Reiki y hoy tengo mi propio espacio de sanación. El material de Maestría es oro puro. Gracias por hacer esto accesible para todos.',
  stars: 5,
  initials: 'VS'
}];
export function TestimonialsSection() {
  return <section className="py-24 px-4 bg-gray-50" data-id="element-219">
      <div className="max-w-7xl mx-auto" data-id="element-220">
        <div className="text-center mb-16" data-id="element-221">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-4" data-id="element-222">
            Lo Que Dicen Nuestros Alumnos
          </h2>
          <div className="flex justify-center gap-1 text-yellow-400 mb-4" data-id="element-223">
            {[1, 2, 3, 4, 5].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-224" />)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-225">
          {TESTIMONIALS.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-shadow border border-gray-100 relative" data-id="element-226">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-violet-100" data-id="element-227" />

              <div className="flex items-center gap-4 mb-6" data-id="element-228">
                <div className="w-12 h-12 rounded-full bg-violet-100 flex items-center justify-center text-violet-600 font-bold text-lg" data-id="element-229">
                  {t.initials}
                </div>
                <div data-id="element-230">
                  <h4 className="font-bold text-gray-900" data-id="element-231">{t.name}</h4>
                  <p className="text-sm text-gray-500" data-id="element-232">
                    {t.city} • {t.age} años
                  </p>
                </div>
              </div>

              <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-233">
                {[...Array(t.stars)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-234" />)}
              </div>

              <p className="text-gray-600 italic leading-relaxed" data-id="element-235">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-236">
          <CTAButton text="¡UNIRME A LA COMUNIDAD!" data-id="element-237" />
        </div>
      </div>
    </section>;
}